import type { Clip, SessionState } from '@/state/types.ts';

// Sort clips by sortOrder for deterministic playback order
export function getSortedClips(clips: Clip[]): Clip[] {
  return [...clips].sort((a, b) => a.sortOrder - b.sortOrder);
}

let tensePool: Clip[] = [];
let calmPool: Clip[] = [];

function shuffle<T>(arr: T[]): T[] {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

export function setClipPools(clips: Clip[]) {
  const sorted = getSortedClips(clips);
  tensePool = shuffle(sorted.filter((c) => (c.arousal ?? 0) > 0.2));
  calmPool = shuffle(sorted.filter((c) => (c.arousal ?? 0) <= 0.2));
}

// Resolve which clip to play for the current index (1-based)
export function getClipForIndex(state: SessionState): Clip | null {
  if (!tensePool.length && !calmPool.length && state.clips.length) {
    setClipPools(state.clips);
  }
  const pick = (pool: Clip[], index: number) => {
    if (pool[index]) return pool[index];
    if (pool.length) return pool[0];
    return null;
  };

  switch (state.clipIndex) {
    case 1:
      return pick(tensePool, 0);
    case 2:
      return pick(tensePool, 1);
    case 3:
      return state.shiftChoice === 'shift' ? pick(calmPool, 0) : pick(tensePool, 2);
    case 4:
      return state.shiftChoice === 'shift' ? pick(calmPool, 1) : pick(tensePool, 3);
    case 5:
      // Always calm for the final track, ensure it is not reused.
      return state.shiftChoice === 'shift' ? pick(calmPool, 2) : pick(calmPool, 0);
    default:
      return null;
  }
}
